interface SourceProps {
  media?: string;
  srcset: string;
  type?: string;
}

function Source({ media, srcset, type }: SourceProps) {
  if (!srcset) {
    return null;
  }

  return <source media={media} srcSet={srcset} type={type} />;
}

export default Source;
export { Source, type SourceProps };
